import React, { ReactNode, useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import { inject, observer } from 'mobx-react';
import { CSSTransition } from 'react-transition-group';
import { useIntl } from 'umi';
import classNames from 'classnames';
import { RootStore } from '@/models';
import s from './switchPanel.less';
import { Icon, Switch } from '@/components';
import { MainChannel } from '@/models/simultaneousInterpretation';

interface ModelState {
  RTCInstance?: RootStore['rtc'];
  simultaneous?: RootStore['simultaneousInterpretation'];
  meeting?: RootStore['meeting'];
}

interface Props extends ModelState {
  children: Element | ReactNode;
  visible: boolean;
  back: () => void;
}

const SwitchChannelH5: React.FC<Props> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
    meeting: store.meeting,
    simultaneous: store.simultaneousInterpretation,
  };
})(
  observer((props) => {
    const { simultaneous, meeting, children, back, visible } = props;
    const { info } = meeting || {};
    const { curChannel, allChannels } = simultaneous || {};
    const { formatMessage } = useIntl();

    return (
      <>
        {ReactDOM.createPortal(
          <div className={s.switchPanel}>
            <CSSTransition
              in={visible}
              timeout={100}
              classNames={{
                enter: s.enter,
                enterActive: s.enterActive,
                enterDone: s.enterDone,
                exit: s.exit,
                exitActive: s.exitActive,
                exitDone: s.exitDone,
              }}
            >
              <div className={s.container}>
                <div className={s.top}>
                  <Icon
                    className={s.close}
                    name="icon-close_nor"
                    onClick={() => {
                      back && back();
                    }}
                  />
                  <span>{formatMessage({ id: 'AUDIENCE_CHANNEL' })}</span>
                </div>
                <div
                  className={s.panel}
                  onClick={(e) => {
                    e.nativeEvent.stopImmediatePropagation();
                  }}
                >
                  <div className={s.block}>
                    <div className={s.box}>
                      {allChannels?.map((item, index: number) => (
                        <>
                          <div
                            key={index}
                            className={s.item}
                            onClick={() => {
                              simultaneous?.setCurChannel(
                                item.yxSubchannelName!,
                                item.languageTag!
                              );
                              back && back();
                            }}
                          >
                            {item.languageName}
                            {curChannel === item.yxSubchannelName ? (
                              <Icon className={s.check} name="icon-check" />
                            ) : (
                              <span className={s.check} />
                            )}
                          </div>
                          {index < allChannels.length - 1 ? <div className={s.line} /> : null}
                        </>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </CSSTransition>
            <div
              className={s.mask}
              onClick={() => {
                back && back();
              }}
            ></div>
          </div>,
          document.body
        )}
      </>
    );
  })
);
export default SwitchChannelH5;
